//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Asides from '@/layout/component/aside.vue';
import Headers from '@/layout/component/header.vue';
import Mains from '@/layout/component/main.vue';
export default {
  name: 'layoutDefaults',
  components: {
    Asides: Asides,
    Headers: Headers,
    Mains: Mains
  },
  data: function data() {
    return {};
  },
  computed: {
    // 是否开启固定 header
    isFixedHeader: function isFixedHeader() {
      return this.$store.state.themeConfig.themeConfig.isFixedHeader;
    }
  },
  watch: {
    // 监听路由的变化
    $route: {
      handler: function handler() {
        this.$refs.layoutDefaultsScrollbarRef.wrap.scrollTop = 0;
      },
      deep: true
    }
  }
};